<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <div class="vx-card overflow-hidden mb-base">
          <!---->
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="">
              <div
                class="p-6 flex justify-between flex-row-reverse items-center"
              >
                <span
                  class="
                    p-3
                    inline-flex
                    rounded-full
                    feather-icon
                    select-none
                    relative
                    text-primary
                  "
                  style="background: rgba(var(--vs-primary), 0.15)"
                >
                  <feather-icon
                    icon="UserIcon"
                    svgClasses="h-10 w-10"
                    class="ml-1"
                  />
                </span>
                <div class="truncate">
                  <h2 class="mb-1 font-bold">{{ counts.Students }}</h2>
                  <h6>Students</h6>
                </div>
              </div>
              <!---->
            </div>
            <!---->
            <div style="border-top: 1px solid black">
              <router-link to="/admin/students">
                <span class="float-left p-4 font_size">Students</span>
                <feather-icon
                  icon="ArrowRightIcon"
                  svgClasses=""
                  class="float-right p-4"
                />
              </router-link>
            </div>
            <!---->
          </div>
        </div>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <div class="vx-card overflow-hidden mb-base">
          <!---->
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="">
              <div
                class="p-6 flex justify-between flex-row-reverse items-center"
              >
                <span
                  class="
                    p-3
                    inline-flex
                    rounded-full
                    feather-icon
                    select-none
                    relative
                    text-primary
                  "
                  style="background: rgba(var(--vs-primary), 0.15)"
                >
                  <feather-icon
                    icon="UserIcon"
                    svgClasses="h-10 w-10"
                    class="ml-1"
                  />
                </span>
                <div class="truncate">
                  <h2 class="mb-1 font-bold">{{ counts.Teachers }}</h2>
                  <h6>Teachers</h6>
                </div>
              </div>
              <!---->
            </div>
            <!---->
            <div style="border-top: 1px solid black">
              <router-link to="/admin/teachers">
                <span class="float-left p-4 font_size">Teachers</span>
                <feather-icon
                  icon="ArrowRightIcon"
                  svgClasses=""
                  class="float-right p-4"
                />
              </router-link>
            </div>
            <!---->
          </div>
        </div>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <div class="vx-card overflow-hidden mb-base">
          <!---->
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="">
              <div
                class="p-6 flex justify-between flex-row-reverse items-center"
              >
                <span
                  class="
                    p-3
                    inline-flex
                    rounded-full
                    feather-icon
                    select-none
                    relative
                    text-primary
                  "
                  style="background: rgba(var(--vs-primary), 0.15)"
                >
                  <feather-icon
                    icon="MapPinIcon"
                    svgClasses="h-10 w-10"
                    class="ml-1"
                  />
                </span>
                <div class="truncate">
                  <h2 class="mb-1 font-bold">{{ counts.ofline_events }}</h2>
                  <h6>Offline Events</h6>
                </div>
              </div>
              <!---->
            </div>
            <!---->
            <div style="border-top: 1px solid black">
              <router-link to="/admin/offline-events">
                <span class="float-left p-4 font_size"
                  >Offline {{ $t("labels.event") }}</span
                >
                <feather-icon
                  icon="ArrowRightIcon"
                  svgClasses=""
                  class="float-right p-4"
                />
              </router-link>
            </div>
            <!---->
          </div>
        </div>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <div class="vx-card overflow-hidden mb-base">
          <!---->
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="">
              <div
                class="p-6 flex justify-between flex-row-reverse items-center"
              >
                <span
                  class="
                    p-3
                    inline-flex
                    rounded-full
                    feather-icon
                    select-none
                    relative
                    text-primary
                  "
                  style="background: rgba(var(--vs-primary), 0.15)"
                >
                  <feather-icon
                    icon="GlobeIcon"
                    svgClasses="h-10 w-10"
                    class="ml-1"
                  />
                </span>
                <div class="truncate">
                  <h2 class="mb-1 font-bold">{{ counts.online_events }}</h2>
                  <h6>Online {{ $t("labels.event") }}</h6>
                </div>
              </div>
              <!---->
            </div>
            <!---->
            <div style="border-top: 1px solid black">
              <router-link to="/admin/online-events">
                <span class="float-left p-4 font_size"
                  >Online {{ $t("labels.event") }}</span
                >
                <feather-icon
                  icon="ArrowRightIcon"
                  svgClasses=""
                  class="float-right p-4"
                />
              </router-link>
            </div>
            <!---->
          </div>
        </div>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <div class="vx-card overflow-hidden mb-base">
          <!---->
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="">
              <div
                class="p-6 flex justify-between flex-row-reverse items-center"
              >
                <span
                  class="
                    p-3
                    inline-flex
                    rounded-full
                    feather-icon
                    select-none
                    relative
                    text-primary
                  "
                  style="background: rgba(var(--vs-primary), 0.15)"
                >
                  <feather-icon
                    icon="MapPinIcon"
                    svgClasses="h-10 w-10"
                    class="ml-1"
                  />
                </span>
                <div class="truncate">
                  <h2 class="mb-1 font-bold">{{ counts.ofline_class }}</h2>
                  <h6>Offline {{ $t("labels.class") }}</h6>
                </div>
              </div>
              <!---->
            </div>
            <!---->
            <div style="border-top: 1px solid black">
              <router-link to="/admin/offline-classes">
                <span class="float-left p-4 font_size"
                  >Offline {{ $t("labels.class") }}</span
                >
                <feather-icon
                  icon="ArrowRightIcon"
                  svgClasses=""
                  class="float-right p-4"
                />
              </router-link>
            </div>
            <!---->
          </div>
        </div>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <div class="vx-card overflow-hidden mb-base">
          <!---->
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="">
              <div
                class="p-6 flex justify-between flex-row-reverse items-center"
              >
                <span
                  class="
                    p-3
                    inline-flex
                    rounded-full
                    feather-icon
                    select-none
                    relative
                    text-primary
                  "
                  style="background: rgba(var(--vs-primary), 0.15)"
                >
                  <feather-icon
                    icon="GlobeIcon"
                    svgClasses="h-10 w-10"
                    class="ml-1"
                  />
                </span>
                <div class="truncate">
                  <h2 class="mb-1 font-bold">{{ counts.online_class }}</h2>
                  <h6>Online {{ $t("labels.class") }}</h6>
                </div>
              </div>
              <!---->
            </div>
            <!---->
            <div style="border-top: 1px solid black">
              <router-link to="/admin/online-classes">
                <span class="float-left p-4 font_size"
                  >Online {{ $t("labels.class") }}</span
                >
                <feather-icon
                  icon="ArrowRightIcon"
                  svgClasses=""
                  class="float-right p-4"
                />
              </router-link>
            </div>
            <!---->
          </div>
        </div>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <div class="vx-card overflow-hidden mb-base">
          <!---->
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="">
              <div
                class="p-6 flex justify-between flex-row-reverse items-center"
              >
                <span
                  class="
                    p-3
                    inline-flex
                    rounded-full
                    feather-icon
                    select-none
                    relative
                    text-primary
                  "
                  style="background: rgba(var(--vs-primary), 0.15)"
                >
                  <feather-icon
                    icon="UserIcon"
                    svgClasses="h-10 w-10"
                    class="ml-1"
                  />
                </span>
                <div class="truncate">
                  <h2 class="mb-1 font-bold">{{ counts.verified_teachers }}</h2>
                  <h6>Verified Teachers</h6>
                </div>
              </div>
              <!---->
            </div>
            <!---->
            <div style="border-top: 1px solid black">
              <router-link to="/admin/teacher-kyc">
                <span class="float-left p-4 font_size">Verified Teachers</span>
                <feather-icon
                  icon="ArrowRightIcon"
                  svgClasses=""
                  class="float-right p-4"
                />
              </router-link>
            </div>
            <!---->
          </div>
        </div>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <div class="vx-card overflow-hidden mb-base">
          <!---->
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="">
              <div
                class="p-6 flex justify-between flex-row-reverse items-center"
              >
                <span
                  class="
                    p-3
                    inline-flex
                    rounded-full
                    feather-icon
                    select-none
                    relative
                    text-primary
                  "
                  style="background: rgba(var(--vs-primary), 0.15)"
                >
                  <feather-icon
                    icon="DollarSignIcon"
                    svgClasses="h-10 w-10"
                    class="ml-1"
                  />
                </span>
                <div class="truncate">
                  <h2 class="mb-1 font-bold">{{ counts.net_profit }} $</h2>
                  <h6>Hobi Earned</h6>
                </div>
              </div>
              <!---->
            </div>
            <!---->
            <div>
              <router-link to="/services/all-services">
                <span class="float-left p-4 font_size">&nbsp;</span>
                <!-- <feather-icon icon='ArrowRightIcon' svgClasses='' class='float-right p-4' /> -->
              </router-link>
            </div>
            <!---->
          </div>
        </div>
      </div>

      <!-- <div class="vx-col sm:w-1/4 w-full text-center mb-base">
        <router-link to="parents">
          <statistics-card-line
            class="dashboard-card"
            @click="$router.push({name:'Parents'})"
            icon="UsersIcon"
            :statistic="ToUsers.parents"
            :statisticTitle="$t('labels.parents')"
            :chartData="subscribersGained.series"
            type="area"
          ></statistics-card-line>
        </router-link>
      </div>

      <div class="vx-col w-full sm:w-1/4 md:w-1/4 mb-base text-center">
       
        <router-link to="service-provider">
          <statistics-card-line
            @click="$router.push({name:''})"
            icon="UsersIcon"
            :statistic="ToUsers.service_providers"
            :statisticTitle="$t('labels.S_provider')"
            :chartData="subscribersGained.series"
            type="area"
          ></statistics-card-line>
        </router-link>
      </div>

      <div class="vx-col sm:w-1/4 w-full text-center mb-base">
       
        <router-link to="/places/all-places">
          <statistics-card-line
            @click="$router.push({name:''})"
            icon="UsersIcon"
            :statistic="Total.place"
            :statisticTitle="$t('labels.places_dashboard')"
            :chartData="subscribersGained.series"
            type="area"
          ></statistics-card-line>
        </router-link>
      </div>
      <div class="vx-col w-full sm:w-1/3 md:w-1/4 mb-base text-center">
        
        <router-link to="/services/all-services">
          <statistics-card-line
            @click="$router.push({name:''})"
            icon="UsersIcon"
            :statistic="Total.services"
            :statisticTitle="$t('labels.services_dashboard')"
            :chartData="subscribersGained.series"
            type="area"
          ></statistics-card-line>
        </router-link>
      </div> -->
    </div>
    <!-- Users By City -->

    <!-- <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 mb-base">
        <Linechart></Linechart>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 mb-base">
        <Linechart></Linechart>
      </div>
    </div> -->
  </div>
</template>
   <script>
import axios from "axios";
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import analyticsData from "./ui-elements/card/analyticsData.js";
import ChangeTimeDurationDropdown from "@/components/ChangeTimeDurationDropdown.vue";
// import VxTimeline from "@/components/timeline/VxTimeline";
// import Linechart from "@/components/dashboard-chart/line-chart/line-chart.vue";

export default {
  data() {
    return {
      subscribersGained: {},
      counts: [],
      Total: [],
      CityByUsers: [],
      places: "",
      services: "",
      service_providers: "",
      parents: "",
      statistic: 0,
      Linechart: "",
    };
  },
  components: {
    VueApexCharts,
    StatisticsCardLine,

    ChangeTimeDurationDropdown,
  },

  mounted() {
    this.getCounts();
    this.getplacesCounts();
    this.getCitybyUsers();
  },

  methods: {
    // Get Parents and Service Provider
    getCounts() {
      axios
        .get("dashboard/getCounts")
        .then((response) => {
          let data = response.data.data;
          this.counts = data;
          console.log(this.counts);
        })

        .catch((e) => {
          this.showError(e);
        });
    },
    // Get Place and Services
    getplacesCounts() {
      let input = {
        places: this.places, // not need to pass
        services: this.services, // not need to pass
      };

      this.axios
        .post("dashboard/getListingCount", input)
        .then((response) => {
          let data = response.data.data;
          this.Total = data;
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    getCitybyUsers() {
      let input = {
        places: this.places, // not need to pass
        services: this.services, // not need to pass
      };

      this.axios
        .get("notification/getUsersByCity", input)
        .then((response) => {
          let data = response.data.data;
          this.CityByUsers = data;
        })
        .catch((e) => {
          this.showError(e);
        });
    },
  },
};
</script>

    <style scoped>
.text {
  font-family: Poppins-Black;
}
</style>